const {Liquid, Tokenizer, evalToken} = require('liquidjs')

export default {
  parse(tagToken) {
    const tokenizer = new Tokenizer(tagToken.args)
    this.items = []
    while (!tokenizer.end()) {
      this.items.push(tokenizer.readValue())
    }
  },
  * render(context, emitter) {
    const token  = this.items[0]
    const value = yield evalToken(token, context)
    const html = value && this.liquid.parseAndRenderSync(value, context.environments)
    emitter.write(html)
  }
}